import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ValimateExecutionSummaryVM } from "../../autogenerated/models";
import { executeTestSession, rerunTestCase } from "../api";

export interface ValimateState {
  isLoading: boolean;
  sessionId: string;
  results: ValimateExecutionSummaryVM;
  rerunningTestCases: Array<TestCaseRerun>;
  downloading: boolean;
}

export interface TestCaseRerun {
  testCaseId: string;
  configurationId: string;
}

const initialState: ValimateState = {
  isLoading: false,
  sessionId: "",
  results: {},
  downloading: false,
  rerunningTestCases: [],
};

export const valimateSlice = createSlice({
  name: "administration",
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsDownloading: (state, action: PayloadAction<boolean>) => {
      state.downloading = action.payload;
    },
    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload;
    },
    setResults: (state, action: PayloadAction<ValimateExecutionSummaryVM>) => {
      state.results = action.payload;
    },
    addRerunningTestCase: (state, action: PayloadAction<TestCaseRerun>) => {
      state.rerunningTestCases = [...state.rerunningTestCases, action.payload];
    },
    removeRerunningTestCase: (state, action: PayloadAction<TestCaseRerun>) => {
      let index = state.rerunningTestCases.findIndex(
        (rtc) =>
          rtc.testCaseId === action.payload.testCaseId &&
          rtc.configurationId === action.payload.configurationId
      );
      state.rerunningTestCases = [
        ...state.rerunningTestCases.slice(0, index),
        ...state.rerunningTestCases.slice(index + 1),
      ];
    },
  },
});

export const { actions } = valimateSlice;

export const setIsDownloading = (downloading: boolean) => (dispatch: any) => {
  dispatch(actions.setIsDownloading(downloading));
};

export const executeSession = (sessionId: string) => {
  return (dispatch: any) => {
    dispatch(actions.setIsLoading(true));
    dispatch(actions.setSessionId(sessionId));
    return executeTestSession(sessionId)
      .then((results) => {
        dispatch(actions.setResults(results));
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => dispatch(actions.setIsLoading(false)));
  };
};

export const rerunTest = (
  sessionId: string,
  testCaseId: string,
  configurationId: string
) => {
  return (dispatch: any) => {
    dispatch(actions.addRerunningTestCase({ testCaseId, configurationId }));
    return rerunTestCase(sessionId, testCaseId, configurationId)
      .then((results) => {
        dispatch(actions.setResults(results));
      })
      .finally(() =>
        dispatch(
          actions.removeRerunningTestCase({ testCaseId, configurationId })
        )
      )
      .catch((error) => {
        console.log(error);
      });
  };
};

export const updateResults =
  (results: ValimateExecutionSummaryVM) => (dispatch: any) => {
    dispatch(actions.setResults(results));
  };
